export const localizedTextDefaultValue = { en: "", ka: "" };